import debug from 'debug';
import plugin from '@core/plugins/lib';
import { ELEMENT_SELECTOR, PLUGIN_NAME } from './index';

const log = debug(`plugins/${PLUGIN_NAME}`);

function measureWidth(contextElement, cssWidth) {
	const test = document.createElement('div');
	test.style.width = cssWidth;
	contextElement.appendChild(test);
	const pixelWidth = test.offsetWidth;
	contextElement.removeChild(test);
	return pixelWidth;
}

class ObserveGrid {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		if (this.options.min === 0) {
			log('No minimum specified [data-observe-grid--min]. Aborting');
			return false;
		}

		if (!window.ResizeObserver) {
			log('ResizeObserver unavailable. Aborting');
			return false;
		}

		const min = this.options.min;
		const wideClass = this.options.wideClass;
		const minToPixels = measureWidth(this.element, min);

		const ro = new ResizeObserver(entries => {
			for (let entry of entries) {
				// Get the element's current dimensions
				const rect = entry.contentRect;

				// `true` if the container is wider than the minimum
				const isWide = rect.width > minToPixels;

				// toggle the class conditionally
				this.element.classList.toggle(wideClass, isWide);
			}
		});

		ro.observe(this.element);
	}

}

ObserveGrid.DEFAULTS = {
	wideClass: 'is-above-min-width',
	min: 0
};

plugin(PLUGIN_NAME, ObserveGrid);



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__observe-grid/plugin.js